// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_d-1";
export var movingGradient = "_d-4";
export var movingGradientBlock = "_d-2";
export var skeleton = "_d-0";
export var skeletonText = "_d-3";